module.exports = __webpack_public_path__ + "assets/images/JMDBOX10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDBOX10.png
// module id = 1395
// module chunks = 1